// extracted by mini-css-extract-plugin
export var content = "CtaSectionEdu-module--content--da406";
export var contentWrapper = "CtaSectionEdu-module--contentWrapper--f19e9";
export var ctaBtn = "CtaSectionEdu-module--ctaBtn--5b8a7";
export var ctaWrapper = "CtaSectionEdu-module--ctaWrapper--bf54a";
export var media = "CtaSectionEdu-module--media--39f87";
export var wrapper = "CtaSectionEdu-module--wrapper--e3dc1";